import OBase from './OBase';
import * as Geometry from '../geometry';
import { GHPlane } from '../../math';

export default class Rotate extends OBase {
  update () {
    if ('Geometry' in this.inputs) {
      this.rotateObjectOnPlane();
    } else {
      this.rotateVectorAroundAxis();
    }
  }

  rotateObjectOnPlane () {
    let geomInputTree = this.getObjectInput('Geometry');
    let angleTree = this.getFloatInput('Angle');
    let planeTree = this.getPlaneInput('Plane', false);

    let output = this.outputs['Geometry'].paramObject;

    let dataTrees = [angleTree, geomInputTree, planeTree];
    let outDataTrees = [];
    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let angle = outDataTrees[0].branches[i][j] + Math.PI / 180.0 * 0.001;
        let geomInput = outDataTrees[1].branches[i][j];
        let plane = outDataTrees[2].branches[i][j];

        let g = Rotate.TransformRotate(geomInput, plane, angle);
        outTree.add(g, outDataTrees[0].paths[i]);
      }
    }
    output.value = outTree;

    return output;
  }

  rotateVectorAroundAxis () {
    let vectorTree = this.getVector3Input('Vector');
    let axisTree = this.getVector3Input('Axis');
    let angleTree = this.getFloatInput('Angle');

    let output = this.outputs['Vector'].paramObject;

    let outDataTrees = [];
    Geometry.makeMultiplePairs([vectorTree, axisTree, angleTree], outDataTrees);

    let outTree = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let vector = outDataTrees[0].branches[i][j];
        let axis = outDataTrees[1].branches[i][j];
        let angle = outDataTrees[2].branches[i][j];

        let g = vector.clone().applyAxisAngle(axis.clone().normalize(), angle);
        outTree.add(g, outDataTrees[0].paths[i]);
      }
    }
    output.value = outTree;

    return output;
  }

  static RotatePoint (p, plane, angle) {
    let dir = (new THREE.Vector3()).subVectors(p, plane.origin);
    dir = dir.applyAxisAngle(plane.normal.normalize(), angle);
    return plane.origin.clone().add(dir);
  }

  static TransformRotate (geomInput, plane, angle) {
    // console.log(geomInput, plane, angle)

    let rotatedGeom;
    if (geomInput instanceof THREE.Geometry) {
      let g = geomInput.clone();
      g.vertices.forEach(v => {
        v.set(v.x - plane.center.x, v.y - plane.center.y, v.z - plane.center.z);
        v.applyAxisAngle(plane.normal, angle);
        v.set(v.x + plane.center.x, v.y + plane.center.y, v.z + plane.center.z);
      });
      /*
      g.vertices.forEach(v => {
        let rotated = this.RotatePoint(v, plane, angle)
        v.copy(rotated)
      })
      */
      rotatedGeom = g;
    } else if (geomInput instanceof THREE.Vector3) {
      let v = geomInput.clone();
      v.set(v.x - plane.center.x, v.y - plane.center.y, v.z - plane.center.z);
      v.applyAxisAngle(plane.normal, angle);
      v.set(v.x + plane.center.x, v.y + plane.center.y, v.z + plane.center.z);
      rotatedGeom = v;
    } else if (geomInput instanceof GHPlane) {
      let plane = geomInput.clone();
      plane.normal.applyAxisAngle(plane.normal, angle);
      plane.xAxis.applyAxisAngle(plane.normal, angle);
      plane.yAxis.applyAxisAngle(plane.normal, angle);
      rotatedGeom = plane;
    } else {
      let paths = geomInput;

      let rotatedPaths = [];
      for (let k = 0; k < paths.length; k++) {
        let path = paths[k];
        rotatedPaths.push([]);
        for (let t = 0; t < path.length; t++) {
          let pt = path[t];
          // let movedIntPt = new ClipperLib.IntPoint(pt.X - plane.center.x, pt.Y - plane.center.z)
          let rotatePt = new ClipperLib.DoublePoint(pt.X - plane.center.x, pt.Y - plane.center.y);
          // let p = new THREE.Vector3(rotatePt.X, 0, rotatePt.Y)
          let p = new THREE.Vector3(rotatePt.X, rotatePt.Y, 0);
          p.applyAxisAngle(plane.normal, angle);
          rotatePt = new ClipperLib.DoublePoint(p.x + plane.center.x, p.y + plane.center.y);
          rotatedPaths[k].push(rotatePt);
        }
      }

      rotatedGeom = rotatedPaths;
    }
    return rotatedGeom;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Rotate.js